<template>
    <div :class="{ 'ly-is-full': isFull }">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="代理商：">
                    <el-input v-model.trim="formInline.belong_agent_name2" maxlength="60" clearable placeholder="代理商"
                        @change="search" style="width:160px"></el-input>
                </el-form-item>
                <el-form-item label="门店：">
                    <el-input v-model.trim="formInline.shop_name2" maxlength="60" clearable placeholder="门店" @change="search"
                        style="width:160px"></el-input>
                </el-form-item>
                <el-form-item label="时间范围：">
                    <el-date-picker style="width:350px" v-model="timers" type="datetimerange" @change="timeChange"
                        range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label=""><el-button @click="search" type="primary" icon="Search"
                        v-show="hasPermission(this.$route.name, 'Search')">查询</el-button></el-form-item>
                <el-form-item label=""><el-button @click="handleEdit('', 'reset')"
                        icon="Refresh">重置</el-button></el-form-item>
            </el-form>
        </div>
        <ul class="order-static" ref="orderStatic">
            <li>代理商总数：{{ orderstatics.agentCount }}</li>
            <li>门店总数：{{ orderstatics.shopCount }}</li>
            <li>代理商充值总数：{{ orderstatics.agentAmount }}</li>
            <li>门店充值总数：{{ orderstatics.shopAmount }}</li>
        </ul>
        <el-table :height="tableHeight" border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
            <!-- <el-table-column type="index" width="60" align="center" label="序号">
                <template #default="scope">
                    <span v-text="getIndex(scope.$index)"></span>
                </template>
            </el-table-column> -->
            <!-- <el-table-column min-width="70" prop="avatar" label="用户头像">
                <template #default="scope">
                    <img :src="scope.row.userinfo.avatar ? scope.row.userinfo.avatar : defaultImg"
                        style="width: 30px;height: 30px" :onerror="defaultImg">
                </template>
            </el-table-column> -->
            <el-table-column min-width="110" prop="belong_agent_name" label="代理商"></el-table-column>
            <el-table-column min-width="150" prop="shop_name" label="门店名称"></el-table-column>
            <el-table-column min-width="100" prop="type_name" label="类型"></el-table-column>
            <el-table-column min-width="150" prop="money" label="卡点">
                <template #default="scope">
                    <span v-if="isNegative(scope.row.money)">{{ scope.row.money }}</span>
                    <span v-else-if="scope.row.type==2">-{{ scope.row.money }}</span>
                    <span v-else>+{{ scope.row.money }}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="150" prop="balance" label="剩余卡点"></el-table-column>
            <el-table-column min-width="150" prop="shop_balance" label="门店当前卡点"></el-table-column>
            <el-table-column min-width="150" prop="operate_user" label="操作人员"></el-table-column>
            <el-table-column min-width="150" prop="operate_user_type_name" label="人员类型"></el-table-column>
            <el-table-column min-width="180" prop="create_datetime" label="日期（充值/消耗日期）"></el-table-column>
            <!--            <el-table-column min-width="100" label="状态">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <el-tag v-if="scope.row.is_active">正常</el-tag>-->
            <!--                    <el-tag v-else type="danger">禁用</el-tag>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column min-width="150" prop="create_datetime" label="创建时间"></el-table-column>-->
            <!--            <el-table-column label="操作" fixed="right" width="180">-->
            <!--                <template slot-scope="scope">-->
            <!--                    &lt;!&ndash;                        v-show="isShowBtn('financeStatisticsAgent','分销设置','Update')"&ndash;&gt;-->
            <!--                    <span class="table-operate-btn" @click="handleEdit(scope.row,'detail')" v-show="isShowBtn('financeStatisticsAgent','代理商财务统计','Retrieve')">详情</span>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
        </el-table>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { dateFormats } from "@/utils/util";
import { mmgjBalanceStatistics, mmgjBalanceStatisticsTongji } from '@/api/api'
import { lyMixins } from "@/mixins/mixins"
export default {
    mixins: [lyMixins],
    components: {
        Pagination,
    },
    name: 'kaDianStatistics',
    data() {
        return {
            isFull: false,
            loadingPage: false,
            formInline: {
                page: 1,
                limit: 10,
            },
            orderstatics: {
                agentCount: 0,
                agentAmount: 0,
                shopCount: 0,
                shopAmount: 0
            },
            defaultImg: require('../../assets/img/avatar.jpg'),
            pageparm: {
                page: 1,
                limit: 10,
                total: 0
            },
            tableData: [],
            timers: [],
        }
    },
    methods: {
        setFull() {
            this.isFull = !this.isFull
        },
        // 表格序列号
        getIndex($index) {
            // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
            return (this.pageparm.page - 1) * this.pageparm.limit + $index + 1
        },
        isNegative(value) {
            if (typeof value === 'string') {
                return value.includes('-'); // 如果是字符串，使用 includes 方法检查是否包含负号
            } else if (typeof value === 'number') {
                return value < 0; // 如果是数字，直接判断是否小于 0
            } else {
                return false; // 其他情况视为不包含负号
            }
        },
        addModule() {
            this.$refs.addModuleFlag.addModuleFn(null, '新增', '1')
        },
        handleEdit(row, flag) {
            let vm = this
            if (flag == 'detail') {
                vm.$refs.addModuleFlag.addModuleFn(row, '详情', '1')
            }
            else if (flag == "reset") {
                this.formInline = {
                    page: 1,
                    limit: 10
                }
                this.pageparm = {
                    page: 1,
                    limit: 10,
                    total: 0
                }
                this.timers = []
                this.search()
            }
        },

        callFather(parm) {
            this.formInline.page = parm.page
            this.formInline.limit = parm.limit
            this.getData()
        },
        search() {
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getData()
            this.getOrderstatistics()
        },
        //订单金额统计获取
        getOrderstatistics() {
            mmgjBalanceStatisticsTongji(this.formInline).then(res => {
                if (res.code == 2000) {
                    this.orderstatics = res.data.data
                }
            })
            //   .finally(() => {
            //  this.$nextTick(() => {
            //     this.$refs.tableref.doLayout();
            //   });
            // });
        },
        //获取列表
        async getData() {
            this.loadingPage = true
            mmgjBalanceStatistics(this.formInline).then(res => {
                this.loadingPage = false
                if (res.code == 2000) {
                    this.tableData = res.data.data
                    this.pageparm.page = res.data.page;
                    this.pageparm.limit = res.data.limit;
                    this.pageparm.total = res.data.total;
                }
            })
        },
        timeChange(val) {
            if (val) {
                this.formInline.beginAt = dateFormats(val[0], 'yyyy-MM-dd hh:mm:ss');
                this.formInline.endAt = dateFormats(val[1], 'yyyy-MM-dd hh:mm:ss');
            } else {
                this.formInline.beginAt = null
                this.formInline.endAt = null
            }
            this.search()
        },
        /**
         * 从URL里下载文件
        */
        // 下载文件
        downloadFile(url) {
            var iframe = document.createElement("iframe")
            iframe.style.display = "none";
            iframe.src = url;
            document.body.appendChild(iframe);
        },
        exportData() {
            // var params = {
            //     type:3,
            //     page: 1,
            //     limit: 9999,
            // }
            // retrieveFinancestatisticsExport(params).then(res => {
            //      if(res.code ==2000) {
            //          this.downloadFile(res.data.data)
            //          //this.$message.warning(res.data.data)
            //      }
            //  })
        }
    },
    created() {
        this.getData()
        this.getOrderstatistics()
    },
}
</script>
<style lang="scss">
.order-static {
    display: flex;
    font-size: 14px;
    background: var(--l-order-statics);
    padding: 10px;

    li {
        margin-right: 30px;

    }
}
</style>